import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { CONFIG, ExceptionService, MessageService, SpinnerService, HttpWrapper } from '../index';
import  { Banners } from './banner.model'; 


let bannersUrl = CONFIG.baseUrls.banner;

@Component({
    selector: 'bp-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.css']
})
  export class BannerComponent implements OnInit, OnDestroy {

    banners: Banners[] = [];
    bottom = false;


    constructor(
      private http: HttpWrapper,
      private exceptionService: ExceptionService,
      private messageService: MessageService,
      private spinnerService: SpinnerService
    ) {
    }

    ngOnInit() {
      
      this.getBanners();
      console.log(this.banners);
    }
  
    fetchBanners() {
      //this.spinnerService.show();
      return <Observable<Banners[]>>this.http
        .get(`${bannersUrl}`)
        .map(res => this.extractData<Banners[]>(res))
        .catch(this.exceptionService.catchBadResponse)
        .finally(() => {
         // this.spinnerService.hide()
        });
    }

    private extractData<T>(res: Response) {
      if (res.status < 200 || res.status >= 300) {
        throw new Error('Bad response status: ' + res.status);
      }
      let body = res.json ? res.json() : null;
      return <T>(body || {});
    }

    getBanners(){
      this.banners = [];

      this.fetchBanners()
      .subscribe(bannersRes => {
        this.banners = bannersRes;
        console.log(this.banners);
      });
    }






    ngOnDestroy(): void {
      
    }
  
    
  }
  


// WEBPACK FOOTER //
// ./src/app/core/banner/banner.component.ts